"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  largePhone: '@media screen and (min-width: 480px)',
  tablet: '@media screen and (min-width: 600px)',
  largeTablet: '@media screen and (min-width: 900px)',
  desktop: '@media screen and (min-width: 1024px)',
  largeDesktop: '@media screen and (min-width: 1400px)',
  biggerScreens: '@media screen and (min-width: 1920px)'
};
exports.default = _default;